function EngToTel() {
    return (
        <div>
            <h2>Eng to Tel</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default EngToTel;